import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "@mantine/core/styles.css";
import "@mantine/notifications/styles.css";
import "./styles/notifications.css";
import App from "./App";
import { BrowserRouter } from "react-router";
import { MantineProvider } from "@mantine/core";
import { ModalsProvider } from "@mantine/modals";
import { MsalProvider } from "@azure/msal-react";
import { msalInstance, initializeMsalInstance } from "./data/msalConfig";
import { Notifications } from "@mantine/notifications";

(async () => {
  await initializeMsalInstance();

  const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement,
  );

  root.render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <BrowserRouter>
          <MantineProvider>
            <ModalsProvider>
              <Notifications />
              <App />
            </ModalsProvider>
          </MantineProvider>
        </BrowserRouter>
      </MsalProvider>
    </React.StrictMode>,
  );
})();
